"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.QuestionTreeNodeButtons = void 0;
const lib_palette_1 = __importDefault(require("@opsbase/lib-palette"));
const web_css_1 = __importDefault(require("@opsbase/web-css"));
const AddIcon_1 = __importDefault(require("@opsbase/web-icons/icons/AddIcon"));
const DeleteIcon_1 = __importDefault(require("@opsbase/web-icons/icons/DeleteIcon"));
const GrabIcon_1 = __importDefault(require("@opsbase/web-icons/icons/GrabIcon"));
const IconButton_1 = __importDefault(require("@opsbase/web-ui/IconButton"));
const react_1 = __importStar(require("react"));
const useFedActions_1 = __importDefault(require("../FedController/useFedActions"));
const useFedDnd_1 = __importDefault(require("../FedController/useFedDnd"));
const useFedSetup_1 = __importDefault(require("../FedController/useFedSetup"));
const makeMyClasses = () => ({
    button: {
        marginLeft: 4,
        marginTop: 12,
    },
    grabIcon: {
        color: lib_palette_1.default.PastelBlue.main,
        cursor: 'grab',
        ['&:active']: {
            cursor: 'grabbing',
        },
        ['&:hover']: {
            color: lib_palette_1.default.BlackCoral.main,
        },
    },
    addIcon: {
        color: lib_palette_1.default.PastelBlue.main,
        ['&:hover']: {
            color: lib_palette_1.default.secondary.main,
        },
    },
    deleteIcon: {
        color: lib_palette_1.default.PastelBlue.main,
        ['&:hover']: {
            color: lib_palette_1.default.error.main,
        },
    },
});
exports.QuestionTreeNodeButtons = react_1.default.memo((props) => {
    const { question, hideAdd = false, hideDrag = false, hideDelete = false } = props;
    const { mode } = (0, useFedSetup_1.default)();
    const { dragging } = (0, useFedDnd_1.default)();
    const { canAdd, doAdd, doDelete } = (0, useFedActions_1.default)();
    const myCss = (0, web_css_1.default)(makeMyClasses);
    const isEditable = mode === 'edit';
    const handleAdd = (0, react_1.useCallback)(e => {
        e.stopPropagation();
        doAdd(question.qId);
    }, [doAdd, question]);
    const handleDelete = (0, react_1.useCallback)(() => {
        doDelete(question.qId);
    }, [doDelete, question]);
    const titleIsBlank = !question.title;
    const draggingMe = dragging === question.qId;
    const draggingElse = !!dragging && dragging !== question.qId;
    const addable = canAdd(question.qId) && !draggingMe && !draggingElse && !titleIsBlank && !hideAdd;
    const deletable = !draggingMe && !draggingElse && !hideDelete;
    const reorderable = !hideDrag && (draggingMe || (!draggingElse && question.title !== ''));
    return (react_1.default.createElement(react_1.default.Fragment, null,
        isEditable && !!reorderable && (react_1.default.createElement(IconButton_1.default, { noOpacity: true, classes: { root: myCss.button + ' dragHandle' }, icon: react_1.default.createElement(GrabIcon_1.default, { className: myCss.grabIcon }) })),
        isEditable && !!addable && (react_1.default.createElement(IconButton_1.default, { noOpacity: true, onClick: handleAdd, classes: { root: myCss.button + ' hideInGhost hideInDrag' }, icon: react_1.default.createElement(AddIcon_1.default, { className: myCss.addIcon }) })),
        isEditable && !!deletable && (react_1.default.createElement(IconButton_1.default, { noOpacity: true, onClick: handleDelete, classes: { root: myCss.button + ' hideInGhost hideInDrag' }, icon: react_1.default.createElement(DeleteIcon_1.default, { className: myCss.deleteIcon }) }))));
});
exports.default = exports.QuestionTreeNodeButtons;
